import { useTranslation } from 'react-i18next';
import Layout from '@/components/feature/Layout';

export default function News() {
  const { t } = useTranslation();

  const news = [
    {
      date: '26.01.2026',
      title: 'Jetzt vormerken: Wir auf der Wire 2026 in Düsseldorf',
      excerpt: 'Im April 2026 ist es wieder soweit: Die im Zweijahresturnus stattfindende Wire steht vor der Tür. Vom 13. bis zum 17. April wird dann die Messe Düsseldorf wieder mit der Fachmesse „Wire" zum Treffpunkt internationaler Fachleute der Draht- und Kabelbranche. An fünf Messetagen werden dann die aktuellsten Technologien und Innovationen präsentiert. Auch wir sind mit eigenem Stand und umfangreichem Leistungsspektrum vertreten. Besuchen Sie uns in Halle 10, Stand 10/A34, und überzeugen Sie sich von unserem Portfolio und unserer kompetenten Beratung. Wir freuen uns auf Ihren Besuch!',
      image: 'https://readdy.ai/api/search-image?query=International%20industrial%20trade%20fair%20exhibition%20hall%20with%20wire%20machinery%20booths%2C%20modern%20exhibition%20stands%2C%20bright%20lighting%2C%20professional%20event%20photography%2C%20Dusseldorf%20trade%20show%20atmosphere&width=600&height=400&seq=news-wire-2026&orientation=landscape',
    },
    {
      date: '19.03.2024',
      title: 'Jetzt vormerken: Wir auf der Wire 2024 in Düsseldorf',
      excerpt: 'Im April 2024 ist es wieder soweit: Die im Zweijahresturnus stattfindende Wire steht vor der Tür. Wir sind mit eigenem Stand und umfangreichem Leistungsspektrum vertreten. Besuchen Sie uns und überzeugen Sie sich von unserem Portfolio.',
      image: 'https://readdy.ai/api/search-image?query=Industrial%20wire%20processing%20machinery%20exhibition%20booth%20at%20trade%20fair%2C%20modern%20manufacturing%20equipment%20display%2C%20professional%20exhibition%20hall%2C%20bright%20lighting&width=600&height=400&seq=news-wire-2024&orientation=landscape',
    },
    {
      date: '05.01.2023',
      title: 'Ausbildung 2023',
      excerpt: 'Wir stellen ein: Auszubildende (m/w/d) zum Industriemechaniker. Werden Sie Teil unseres Teams und starten Sie Ihre Ausbildung bei der Maschinenfabrik Bock.',
      image: 'https://readdy.ai/api/search-image?query=Young%20apprentice%20training%20in%20a%20modern%20German%20industrial%20workshop%2C%20precision%20metalworking%20machinery%2C%20professional%20vocational%20education%2C%20bright%20workshop%20environment&width=600&height=400&seq=news-training-2023&orientation=landscape',
    },
    {
      date: '16.05.2022',
      title: 'Jetzt vormerken: Wir auf der Wire 2022 in Düsseldorf',
      excerpt: 'Im Juni 2022 ist es wieder soweit: Die im Zweijahresturnus stattfindende Wire steht vor der Tür. Wir sind mit eigenem Stand und umfangreichem Leistungsspektrum vertreten.',
      image: 'https://readdy.ai/api/search-image?query=Industrial%20wire%20and%20cable%20trade%20fair%20exhibition%2C%20modern%20machinery%20display%20booths%2C%20large%20exhibition%20hall%2C%20professional%20event%20photography&width=600&height=400&seq=news-wire-2022&orientation=landscape',
    },
    {
      date: '15.06.2018',
      title: 'Unser Katalog',
      excerpt: 'Wir stellen unseren Katalog vor, siehe Download. In unserem Katalog finden Sie alle Informationen zu unseren Maschinen und Anlagen.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20industrial%20product%20catalog%20brochure%20on%20modern%20desk%2C%20manufacturing%20machinery%20images%2C%20clean%20business%20photography%2C%20warm%20lighting&width=600&height=400&seq=news-catalog-2018&orientation=landscape',
    },
    {
      date: '11.02.2016',
      title: 'Jetzt vormerken: Wir auf der Wire & Tube 2018 in Düsseldorf',
      excerpt: 'Im April ist es wieder soweit: Die im Zweijahresturnus stattfindende Wire & Tube steht vor der Tür. Wir sind mit eigenem Stand und umfangreichem Leistungsspektrum vertreten.',
      image: 'https://readdy.ai/api/search-image?query=Large%20international%20trade%20fair%20for%20wire%20and%20tube%20industries%2C%20modern%20exhibition%20hall%2C%20industrial%20machinery%20displays%2C%20professional%20event%20photography&width=600&height=400&seq=news-wire-tube-2018&orientation=landscape',
    },
  ];

  const formatDate = (dateStr: string) => {
    const [day, month, year] = dateStr.split('.');
    return `${day}.${month}.${year}`;
  };

  return (
    <Layout>
      {/* Page Header */}
      <div className="bg-foreground-900 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <span className="text-accent-400 text-sm font-medium uppercase tracking-wider mb-4 block">
            {t('nav.news')}
          </span>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
            {t('newsPage.title')}
          </h1>
          <p className="text-white/60 text-base md:text-lg max-w-2xl">
            {t('newsPage.subtitle')}
          </p>
        </div>
      </div>

      {/* News Grid */}
      <section className="py-16 md:py-24 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {news.map((item) => (
              <article
                key={item.date + item.title}
                className="group bg-background-50 rounded-xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-500 hover:-translate-y-1 border border-background-200"
              >
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                    <span className="text-sm text-foreground-500">{formatDate(item.date)}</span>
                  </div>
                  <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-3 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-600 text-sm leading-relaxed mb-4">
                    {item.excerpt}
                  </p>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer">
                    {t('newsPage.readMore')}
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </Layout>
  );
}